
import Book from "../../../../Assets/book.png";
import swasthyam from "../../../../Assets/swasthyam.png";
import backgroundShade from "../../../../Assets/backgroundshade.svg"
import backImg from "../../../../Assets/backimg.svg"
import Aagni from "../../../../Assets/Isolation_Mode (1).png";
import { useRef } from "react";
import "./features.css";
import ReactOwlCarousel from "react-owl-carousel";

export const FeaturesCarousel = () => {

    const sliderRef = useRef(null);
    const features = ['feature-1', 'feature-2', 'feature-3', 'feature-4']

    const handleSlideClick = () => {
        sliderRef.current.slickNext();
    };

    return <div>


        <ReactOwlCarousel loop responsive={{
            300: {
                items: 1,
                margin: 20
            },
            600: {
                items: 3
            }
        }}>
            {features.map((_, index) => (<div key={`carousel-item-${index}`} className="feature-item">
                <div onClick={handleSlideClick} >
                    <h4 className="m-0 p-0" style={{ fontWeight: 700, fontSize: "20px", fontFamily: '"Exo 2", sans-serif' }}>Course <br />Material</h4>
                    <p className="m-0 p-0 mt-2" style={{ fontWeight: 400, fontSize: "14px" }}>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less </p>
                    <div style={{ display: "flex", justifyContent: "end" }}>
                        <img src={Book} style={{ width: "20%" }} />
                    </div>
                </div>
            </div>))}
        </ReactOwlCarousel>

    </div>
}